import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface StatsCardProps {
    title: string;
    value: string | number;
    assignedStudents?: string | number;
    icon?: IconDefinition;
    iconColor?: string;
    valueColor?: string;
    className?: string;
    synced_count?: any
    style?: React.CSSProperties;
    onClick?: any
}

export default function StatsCard({
    title,
    value,
    assignedStudents,
    icon,
    synced_count,
    iconColor = "primary",
    valueColor = "primary",
    className = "",
    style = {},
    onClick
}: StatsCardProps) {
    return (
        <Card className={`h-76 ${className}`} style={style} onClick={onClick}>
            <Card.Body>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="">
                        <h3 className={`text-${valueColor} fw-bold mb-1`} style={{ fontSize: '1.1rem' }}>
                            {typeof value === 'number' ? value.toLocaleString() : value}
                            {assignedStudents &&
                                <span className='text-secondary' style={{ fontSize: '.9rem' }}>
                                    /{typeof assignedStudents === 'number' ? assignedStudents.toLocaleString() : assignedStudents}
                                </span>
                            }
                        </h3>
                        <span className="text-muted" style={{ fontSize: '0.7rem' }}>{title}</span> <br />
                    </div>
                    {icon && (
                        <div className="align-self-center ms-3">
                            <FontAwesomeIcon
                                icon={icon}
                                className={`text-${iconColor}`}
                                style={{ fontSize: '2rem' }}
                            />
                        </div>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
}

export type { StatsCardProps };
